import { isGoogleDocsPreviewEnabled } from './env';
import { getFileExtension, getIsImage, getIsVideo } from './fileExtension';

import { FILE_EXTENSIONS } from '~/components/NewDocumentViewer/constants';

export const getIsPreviewUnavailable = fileName => {
  if (isGoogleDocsPreviewEnabled) return false;

  if (getIsImage(fileName) || getIsVideo(fileName)) return false;

  const fileExtension = getFileExtension(fileName);
  const isPreviewUnavailable = !Object.keys(FILE_EXTENSIONS).includes(fileExtension);

  return isPreviewUnavailable;
};
